import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  
  static targets = ['input', 'submitButton']
  
  itemTypeInputChanged() {
    const isEmpty = this.inputTarget.value.trim() === '';
    this.submitButtonTarget.disabled = isEmpty
  }
}
